package com.cybersoftsolution.cybersoftsolutionweb.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.api.authenticate
import com.cybersoftsolution.cybersoftsolutionweb.models.AuthResponse
import com.cybersoftsolution.cybersoftsolutionweb.models.UserInfo
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.varabyte.kobweb.browser.storage.BooleanStorageKey
import com.varabyte.kobweb.browser.storage.StringStorageKey
import com.varabyte.kobweb.browser.storage.getItem
import com.varabyte.kobweb.browser.storage.setItem
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import kotlinx.browser.localStorage
import kotlinx.coroutines.delay


object WebStorage {

    private val REMEMBER_KEY = BooleanStorageKey("remember", defaultValue = null)
    private val USER_ID_KEY = StringStorageKey("userId",defaultValue =null)
    private val USER_NAME_KEY = StringStorageKey("userName",defaultValue =null)
    private val AUTHORIZATION_TOKEN_KEY = StringStorageKey("authorizationToken",defaultValue =null)
    private val USER_EMAIL_KEY = StringStorageKey("userEmail",defaultValue =null)
    private val USER_EMAIL_VERIFIED_KEY = BooleanStorageKey("userEmailVerified",defaultValue =null)
    private val USER_PHONE_KEY = StringStorageKey("userPhone",defaultValue =null)
    private val USER_PICTURE_KEY = StringStorageKey("userPicture",defaultValue =null)



    private val IS_SUBSCRIBED_KEY = BooleanStorageKey("subscribed",null)
    private val EMAIL_SUBSCRIBED_KEY = StringStorageKey("subscribed_email",null)

    fun rememberSubscriber(
        isSubscribe: Boolean,
        email: String,
    ) {
        if (isSubscribe) {
            localStorage.setItem(IS_SUBSCRIBED_KEY, isSubscribe)
            localStorage.setItem(EMAIL_SUBSCRIBED_KEY, email)
        } else {
            localStorage.setItem(IS_SUBSCRIBED_KEY, false)
            localStorage.setItem(EMAIL_SUBSCRIBED_KEY, email)
        }

    }

    fun getRememberedSubscriber(): Map<Boolean, String> {
        return  mapOf(
            Pair(localStorage.getItem(IS_SUBSCRIBED_KEY) ?: false, localStorage.getItem(EMAIL_SUBSCRIBED_KEY) ?: "")
        )
    }

    fun logout() {
        with(localStorage) {
//            removeItem(REMEMBER_KEY.name)
            removeItem(USER_ID_KEY.name)
            removeItem(AUTHORIZATION_TOKEN_KEY.name)
            removeItem(USER_NAME_KEY.name)
//            removeItem(USER_EMAIL_KEY.name)
            removeItem(USER_EMAIL_VERIFIED_KEY.name)
            removeItem(USER_PHONE_KEY.name)
            removeItem(USER_PICTURE_KEY.name)
        }

    }


    fun getUserId(): String {
        return localStorage.getItem(USER_ID_KEY) ?: ""
    }

    fun getUserInfo():UserInfo {
        return UserInfo(
            id = localStorage.getItem(USER_ID_KEY),
            name = localStorage.getItem(USER_NAME_KEY),
            email = localStorage.getItem(USER_EMAIL_KEY),
            emailVerified = localStorage.getItem(USER_EMAIL_VERIFIED_KEY),
            phone = localStorage.getItem(USER_PHONE_KEY),
            picture = localStorage.getItem(USER_PICTURE_KEY),
            authorizationToken = localStorage.getItem(AUTHORIZATION_TOKEN_KEY),
        )
    }




    fun rememberLogin(
        remember: Boolean?,
        userId: String?,
        authorizationToken: String?,
        userName: String?,
        userEmail: String?,
        userEmailVerified: Boolean?,
        userPhone: String?,
        userPicture: String?,

        ) {
        with(localStorage) {
            remember?.let { setItem(REMEMBER_KEY, remember) }
            userId?.let { setItem(USER_ID_KEY, userId) }
            authorizationToken?.let { setItem(AUTHORIZATION_TOKEN_KEY, authorizationToken) }
            userName?.let { setItem(USER_NAME_KEY, userName) }
            userEmail?.let { setItem(USER_EMAIL_KEY, userEmail) }
            userEmailVerified?.let { setItem(USER_EMAIL_VERIFIED_KEY, userEmailVerified) }
            userPhone?.let { setItem(USER_PHONE_KEY, userPhone) }
            userPicture?.let { setItem(USER_PICTURE_KEY, userPicture) }

        }

    }

    fun getUserEmailIfRemembered(): String {
        return if (localStorage.getItem(REMEMBER_KEY) == true) {
             localStorage.getItem(USER_EMAIL_KEY) ?: ""
        } else ""
    }
    fun getRememberedLogin(): Boolean {
        return localStorage.getItem(REMEMBER_KEY) ?: false
    }






}

